/**
 * JURO — add the ticked free add-ons after the racket lands in the cart
 * ------------------------------------------------------------------
 * Listens for the theme's own cart:update from the product form. When the
 * racket was added without error, posts the ticked add-ons to /cart/add.js
 * with the cart sections, then dispatches a cart:update of its own so the
 * drawer redraws with them in. The protector follows the racket quantity;
 * add-ons marked data-once (the e-book) are added only if not in the cart.
 *
 * Guarded so two buy boxes on one page (main + sticky bar) wire it once.
 */

import { CartAddEvent, ThemeEvents } from '@theme/events';

if (!window.__juroAddons) {
  window.__juroAddons = true;

  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  document.addEventListener(ThemeEvents.cartUpdate, async (event) => {
    const data = (event.detail && event.detail.data) || {};
    if (data.source !== 'product-form-component' || data.didError) return;

    const box = document.querySelector(`.juro-addons[data-product-id="${data.productId}"]`);
    if (!box) return;
    const ticked = [...box.querySelectorAll('input[data-juro-addon]:checked')];
    if (!ticked.length) return;

    try {
      const cart = await fetch(`${root}cart.js`).then((r) => r.json());
      const inCart = new Set(cart.items.map((i) => i.variant_id));
      const qty = Math.max(1, Number(data.itemCount) || 1);

      const items = [];
      for (const input of ticked) {
        const id = Number(input.value);
        if (input.dataset.once === 'true') {
          if (!inCart.has(id)) items.push({ id, quantity: 1 });
        } else {
          items.push({ id, quantity: qty });
        }
      }
      if (!items.length) return;

      const sections = [...document.querySelectorAll('cart-items-component')]
        .map((el) => el.dataset.sectionId)
        .filter(Boolean);

      const res = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items, sections: sections.join(',') }),
      }).then((r) => r.json());

      if (res.status) return; // error response: leave the racket in, skip the extras

      document.dispatchEvent(
        new CartAddEvent({}, 'juro-addons', {
          source: 'juro-addons',
          itemCount: items.reduce((n, i) => n + i.quantity, 0),
          sections: res.sections,
        })
      );
    } catch (e) {
      // The racket is in the cart either way; the gifts are a bonus.
    }
  });
}
